import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How long does it take to get a custom suit?',
      answer: 'Our custom suits are typically delivered within 6 to 8 weeks* from your final fitting. This timeframe allows our master tailors to handcraft your garment with meticulous attention to detail. Rush orders may be available upon request for an additional fee.'
    },
    {
      question: 'Do you offer house calls?',
      answer: 'Yes! Our traveling consultants provide convenient house and office calls nationwide. We bring our complete fabric collection and expertise directly to your location. Simply schedule an appointment and we\'ll come to you at a time that works best for your schedule.'
    },
    {
      question: 'What is included in a custom suit?',
      answer: 'Every custom suit includes precise measurements taken by our expert consultants, your choice of premium fabrics from renowned mills, complete style customization (lapels, buttons, pockets, lining), expert handcrafted construction by master tailors, and multiple fittings to ensure perfect fit.'
    },
    {
      question: 'How much does a custom suit cost?',
      answer: 'Custom suit pricing varies based on fabric selection and customization options. Our suits typically range from mid to premium pricing tiers. We offer package deals for multiple suits or suit and shirt combinations. Contact us for detailed pricing and current specials.'
    },
    {
      question: 'Can I see fabric samples before ordering?',
      answer: 'Absolutely! We mail swatches to our repeat customers. Simply request swatches through our contact form or by phone, and we\'ll send you a selection of samples. During consultations, we also bring our complete fabric collection for you to see and feel.'
    },
    {
      question: 'Do you make custom shirts as well?',
      answer: 'Yes! We specialize in custom dress shirts tailored to your exact measurements. Choose from luxury fabrics, collar styles, cuff designs, and add personalized monograms. Like our suits, every shirt is handcrafted to ensure perfect fit and exceptional quality.'
    },
    {
      question: 'What areas do you serve?',
      answer: 'We provide nationwide service across all 50 states. Our traveling consultants bring the luxury of custom tailoring directly to your home or office, no matter where you\'re located in the United States.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Frequently Asked <span className="text-[#C9A961]">Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our <strong>custom tailoring services</strong>
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden border border-gray-100 hover:border-[#C9A961]/30 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-[#C9A961] flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-gray-50 rounded-2xl p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-6">
            Our team is here to help. Contact us for personalized assistance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:866-857-8487" 
              className="inline-flex items-center justify-center bg-[#C9A961] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#B89851] transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call 866-857-8487
            </a>
            <a 
              href="mailto:info@britishtailors.com" 
              className="inline-flex items-center justify-center bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}